import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=207718fc&scoped=true"
import script from "./PhotoModal.vue?vue&type=script&lang=js"
export * from "./PhotoModal.vue?vue&type=script&lang=js"
import style0 from "./PhotoModal.vue?vue&type=style&index=0&id=207718fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207718fc",
  null
  
)

export default component.exports